import React, { useState, useEffect } from 'react';
import { marked } from 'marked';
import { config } from '../config';
import './scss/WhatsNew.scss';

const WhatsNew = () => {
    const [releases, setReleases] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReleases = async () => {
            try {
                const res = await fetch(`${config.API_URI}/v1/releases`, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    credentials: 'include',
                });
                if (res.ok) {
                    const data = await res.json();
                    setReleases(data);
                    // Mark the latest release as seen
                    if (data.length > 0 && data[0].version) {
                        localStorage.setItem('zoobbe_last_seen_release', data[0].version);
                        localStorage.setItem('zoobbe_release_tip_dismissed', data[0].version);
                    }
                }
            } catch (err) {
                console.error('Failed to fetch releases:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchReleases();
    }, []);

    if (loading) {
        return (
            <div className="whats-new-page">
                <div className="whats-new-loading">
                    <div className="loading-spinner"></div>
                </div>
            </div>
        );
    }

    if (releases.length === 0) {
        return (
            <div className="whats-new-page">
                <div className="whats-new-empty">
                    <h2>What's New</h2>
                    <p>No updates available yet. Check back soon!</p>
                </div>
            </div>
        );
    }

    return (
        <div className="whats-new-page">
            <div className="whats-new-header">
                <h1>What's New</h1>
                <p>See the latest features and improvements</p>
            </div>

            <div className="whats-new-feed">
                {releases.map((release, index) => (
                    <div key={release._id} className="release-card">
                        <div className="release-card-header">
                            <div className="release-meta">
                                <span className="release-version">{release.version}</span>
                                {index === 0 && <span className="release-badge">Latest</span>}
                            </div>
                            <h2 className="release-title">{release.title}</h2>
                            <p className="release-date">
                                {new Date(release.date).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric',
                                })}
                            </p>
                        </div>

                        {release.content && (
                            <div
                                className="release-content"
                                dangerouslySetInnerHTML={{ __html: marked(release.content) }}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default WhatsNew;
